"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _remarkable = require("remarkable");

require("./markdown.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Markdown = function Markdown(_ref) {
  var source = _ref.source,
      className = _ref.className,
      options = _ref.options,
      element = _ref.element;

  if (!source) {
    return null;
  } // Don't try to render if no text passed in


  var remarkable = new _remarkable.Remarkable('default', options);
  var html = remarkable.render(source);
  return /*#__PURE__*/_react["default"].createElement(element, {
    className: "markdown ".concat(className),
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};

Markdown.propTypes = {
  source: _propTypes["default"].string,
  className: _propTypes["default"].string,
  options: _propTypes["default"].object,
  // eslint-disable-line
  element: _propTypes["default"].elementType
};
Markdown.defaultProps = {
  source: null,
  className: '',
  options: {
    html: true
  },
  element: 'div'
};
var _default = Markdown;
exports["default"] = _default;